define('modules/home/dashboard/dashboard.controller',[
    "client"
], function(
    Prospector)
{
    Prospector.module("HomeApp.Dashboard", function(Dashboard, Prospector, Backbone, Marionette, $, _){
        Dashboard.Controller = {
            loadDashBoard: function (options) {
                var that = this;
                var mPros = Prospector;
                require(["modules/home/sidebar/views/search.view"],
                    function (HomeDashBoardView) {
                        var HomeDashBoardView = HomeDashBoardView;
                        if(
                            (window.location.href.indexOf("chrome-exten") == -1) ||
                            (window.debug && window.location.href.indexOf("localhost") > -1) ||
                            options
                        ){
                            var homeDashBoardView = new HomeDashBoardView();
                            mPros.mainRegion.show(homeDashBoardView);
                        } else{
                            chrome.tabs.queryAsync = function (queryInfo) {
                                return new Promise(function (resolve, reject) {
                                    try {
                                        chrome.tabs.query(queryInfo, function (tabs) {
                                            resolve(tabs);
                                        });
                                    } catch (ex) {
                                        reject(ex.message);
                                    }
                                })
                            };

                            var isURL = function(str) {
                                var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
                                    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|'+ // domain name
                                    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
                                    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
                                    '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
                                    '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
                                return pattern.test(str);
                            };

                            var checkIfValidURL = function (url) {
                                return (url.indexOf("https://rcm.boardex.com/web/") > -1 || url.indexOf("https://www.linkedin.com/in/") > -1 || url.indexOf("https://www.linkedin.com/sales/people") > -1 || url.indexOf(".force.com") > -1 || url.indexOf(".salesforce.com") > -1);
                            };
                            var getInfo = function (url) {
                                var mDoc = document;
                                if (url.indexOf("https://rcm.boardex.com/web/") > -1) {
                                    var matchesCount = url.split("/").length - 1;
                                    if (matchesCount == 4 || matchesCount == 5) {
                                        throw "Invalid profile";
                                    }
                                    else if (matchesCount != 6) throw "New URL format";

                                    var index = url.indexOf("/");
                                    var indexOfSlashes = [];

                                    //find each occurence of / and add to list of /
                                    while (index >= 0) {
                                        indexOfSlashes.push(index);
                                        index = url.indexOf("/", index + 1);
                                    }

                                    var link = "BoardEx";
                                    var type = url.slice(indexOfSlashes[3] + 1, indexOfSlashes[4]);
                                    var id = url.slice(indexOfSlashes[4] + 1, indexOfSlashes[5]);
                                    if (type == "individual") type = "person";
                                    if (type == "organisation") type = "organization";
                                    return info = {
                                        link:link,
                                        type:type,
                                        id:id
                                    };
                                } else if((url.indexOf("lightning.force.com") > -1)){
                                    var link = "SalesforceLightning";
                                    var type = undefined;
                                    var id = undefined;
                                    return info = {
                                        link:link,
                                        type:type,
                                        id:id
                                    };

                                } else if(url.indexOf(".force.com") > -1 || url.indexOf(".salesforce.com") > -1){
                                    var link = "Salesforce";
                                    var type = undefined;
                                    var id = undefined;
                                    return info = {
                                        link:link,
                                        type:type,
                                        id:id
                                    };
                                } else if(url.indexOf("https://www.linkedin.com/sales/people") > -1){
                                    var link = "LinkedInNavigator";
                                    var type = undefined;
                                    var id = undefined;
                                    return info = {
                                        link:link,
                                        type:type,
                                        id:id
                                    };
                                } else {
                                    var link = "LinkedIn";
                                    var type = undefined;
                                    var id = undefined;
                                    return info = {
                                        link:link,
                                        type:type,
                                        id:id
                                    };
                                }
                            };
                            var getURL = function () {
                                var mDoc = document;
                                var queryInfo = {active: true, currentWindow: true};
                                return chrome.tabs.queryAsync(queryInfo)
                                    .then(function (tabs) {
                                        var tabsInfo = null;
                                        try {
                                            var url = tabs[0].url;
                                            var id = tabs[0].id;
                                            tabsInfo = {url:url, id:id};
                                        } catch (err) {
                                            console.log(err);
                                        }
                                        return tabsInfo;
                                    })
                                    .catch(function (err) {
                                        console.log(err);
                                    });
                            };
                            var validateUrl = function (value) {
                                return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value);
                            };
                            var homeDashboardSearch = function(){
                                var homeDashBoardView = null;
                                homeDashBoardView = new HomeDashBoardView();
                                mPros.mainRegion.show(homeDashBoardView);

                                // Fill in main input if current open tab is a valid url
                                chrome.tabs.getSelected(null, function(tab) {
                                    if(validateUrl(tab.url)){
                                        var currentUrl = new URL(tab.url);
                                        var finalUrl = currentUrl.hostname;
                                        if(currentUrl.hostname.indexOf("www.") > -1){
                                            finalUrl = currentUrl.hostname.replace("www.", '');
                                        }
                                        Prospector.trigger('runSubSearch',{
                                            state: true,
                                            main: finalUrl,
                                            tab: 'organization'
                                        });
                                    }
                                });
                            };
                            var runRoleSearch = function(person) {
                                var homeDashBoardView = null;
                                homeDashBoardView = new HomeDashBoardView();
                                mPros.mainRegion.show(homeDashBoardView);
                                window.utils.writeSessionStorageField("showTab", "people");

                                window.setTimeout(function(){
                                    $(".searchViewHolder").show();
                                    $("#searchToggle").bootstrapSwitch('state', true);
                                    $(".searchBar").eq(2).val(person.organizations);
                                    $(".searchBar").eq(3).val(person.role);
                                    $(".searchBtn").click();
                                }, 500);
                            }
                            var retrieveInformation = function () {
                                console.log("retrieve info running");
                                var mDoc = document;
                                getURL()
                                    .then(function (tabsInfo) {
                                        if (checkIfValidURL(tabsInfo.url)) {
                                            var info = getInfo(tabsInfo.url);
                                            console.log("info = ", info);
                                            if (info.link == "BoardEx") {
                                                mPros.navigate("#profile/" + info.type + "/20/" + info.id, true);
                                            } else if (info.link == "LinkedIn") {
                                                console.log("is linked in");
                                                chrome.runtime.onMessage.addListener(function (request, sender) {
                                                    console.log("request = ", request);
                                                    if (request.action == "getSource") {
                                                        var person = request.source;
                                                        mPros.navigate("#resolve/person?firstName=" + person.fname + "&lastName=" + person.lname + "&company=" + person.organizations, true);
                                                        console.log("mpros ran");
                                                    }
                                                });
                                                chrome.tabs.executeScript(null, {
                                                    file: "getPageSource.js"
                                                }, function () {
                                                    // If you try and inject into an extensions page or the webstore/NTP you'll get an error
                                                    if (chrome.runtime.lastError) {
                                                        console.log('There was an error injecting script : \n' + chrome.runtime.lastError.message);
                                                    }
                                                });
                                            } else if(info.link == "Salesforce"){
                                                console.log("is Salesforce");
                                                chrome.runtime.onMessage.addListener(function (request, sender) {
                                                    console.log("request = ", request);
                                                    if (request.action == "getSalesforceSource") {
                                                        var person = request.source;
                                                        mPros.navigate("#resolve/person?firstName=" + person.fname + "&lastName=" + person.lname + "&company=" + person.organizations + "&emailDomain=" + person.domain, true);
                                                        console.log("mpros ran Salesforce");
                                                    }else if(request.action == "sendToDashboard"){
                                                        homeDashboardSearch();
                                                    }
                                                });
                                                chrome.tabs.executeScript(null, {
                                                    file: "getSalesforceData.js"
                                                }, function () {
                                                    // If you try and inject into an extensions page or the webstore/NTP you'll get an error
                                                    if (chrome.runtime.lastError) {
                                                        console.log('There was an error injecting script : \n' + chrome.runtime.lastError.message);
                                                    }
                                                });
                                            } else if(info.link == "SalesforceLightning"){
                                                chrome.runtime.onMessage.addListener(function (request, sender) {
                                                    if (request.action == "getSalesforceLightning") {
                                                        var person = request.source;
                                                        mPros.navigate("#resolve/person?firstName=" + person.fname + "&lastName=" + person.lname + "&company=" + person.organizations + "&emailDomain=" + person.domain, true);
                                                    } else if(request.action == "sendToDashboard"){
                                                        homeDashboardSearch();
                                                    }
                                                });
                                                chrome.tabs.executeScript(null, {
                                                    file: "getSalesforceLightning.js"
                                                }, function () {
                                                    // If you try and inject into an extensions page or the webstore/NTP you'll get an error
                                                    if (chrome.runtime.lastError) {
                                                        console.log('There was an error injecting script : \n' + chrome.runtime.lastError.message);
                                                    }
                                                });
                                            } else if(info.link == "LinkedInNavigator"){
                                                chrome.runtime.onMessage.addListener(function (request, sender) {
                                                    console.log("request = ", request);
                                                    var person = request.source;
                                                    if (request.action == "getLinkedinNav") {
                                                        mPros.navigate("#resolve/person?firstName=" + person.fname + "&lastName=" + person.lname + "&company=" + person.organizations, true);
                                                    } else if (request.action === "runRoleSearch"){
                                                        runRoleSearch(person)
                                                    }
                                                });
                                                chrome.tabs.executeScript(null, {
                                                    file: "getLinkedinNavData.js"
                                                }, function () {
                                                    // If you try and inject into an extensions page or the webstore/NTP you'll get an error
                                                    if (chrome.runtime.lastError) {
                                                        console.log('There was an error injecting script : \n' + chrome.runtime.lastError.message);
                                                    }
                                                });
                                            }
                                        } else {
                                            homeDashboardSearch();
                                        }

                                        return true;
                                    });
                            };
                            retrieveInformation();
                        }
                    });
            }
        }});

    return Prospector.HomeApp.Dashboard.Controller;

});
